import { render } from "./Recap.component.vue?vue&type=template&id=727121ae&scoped=true"
import script from "./Recap.component.vue?vue&type=script&lang=js"
export * from "./Recap.component.vue?vue&type=script&lang=js"

import "./Recap.component.vue?vue&type=style&index=0&id=727121ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727121ae"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
